import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { TabProvider } from 'context/TabContext';
import CustomTabs from 'components/Tabs/Tabs';
import Profession from './Profession';
import Base from './Base';
import Medical from './Medical';
import Residence from './Residence';
import Professional from './Professional';
import Sport from './Sport';
import Activities from './Activities';
import { useUserSession } from 'context/UserContext';
import { useHistory } from 'react-router-dom';

interface TabData {
  id: number;
  title: string;
  component: React.ReactNode;
}

const Questionnaires: React.FC = () => {
  const dataTabs: TabData[] = [
    { id: 0, title: 'Profissão', component: <Profession /> }, //0
    { id: 1, title: 'Base', component: <Base /> }, //1
    { id: 2, title: 'Médico', component: <Medical onSubmitFormHandle={onSubmitHandle}/> }, //2
    { id: 3, title: 'Residência', component: <Residence /> }, //3
    { id: 4, title: 'Profissional', component: <Professional /> }, //4
    { id: 5, title: 'Desporto', component: <Sport onSubmitFormHandle={onSubmitHandle} /> }, //5
    { id: 6, title: 'Actividades', component: <Activities onSubmitFormHandle={onSubmitHandle} /> }, //6
  ];
  const { userData } = useUserSession();
  const history = useHistory();

  useEffect(() => {
    sessionStorage.removeItem('extraQuestionsData');

    if (!userData || (typeof userData === 'object' && Object.keys(userData).length === 0)) {
      history.push('/not-found');
    }
  }, []);

  interface ProcessedFormElements {
    childItems: any[];
    errorList: any[];
    selectedSection: any[];
  }

  function processFormElements(event: React.FormEvent<HTMLFormElement>, question: any): ProcessedFormElements {
    const form = event.currentTarget;
    let childItems: any[] = [];
    let errorList: any[] = [];
    let selectedSection: any[] = [];

    Array.from(form.elements).forEach((element: any) => {
      if (element && element.type === 'radio' && element.checked) {
        let selected = question.find((section: any) => {
          if (section.items) {
            return section.items.find((item: any) => `${item.value}-true` === element.id);
          }
          return false; // Retorna false se section.items não existir ou se o item não for encontrado
        })?.items.find((item: any) => `${item.value}-true` === element.id); // Encontra o item dentro da lista encontrada

        if ((selected?.items && selected?.items?.length > 0) && selected.parentType === 'PARENT') {
          if (selectedSection.length === 0 || (selectedSection && !selectedSection.some(x => x.value === selected.value))) {
            selectedSection.push(selected);
          }
          childItems = selected.items;
        }

        let childItemsSelected = childItems.find((item: any) => `${item.value}-false` === element.id);
        if (childItemsSelected) {
          if (errorList && !errorList.some(x => x.value === childItemsSelected.value)) {
            errorList.push(childItemsSelected);
          }
        }
      }
    });

    return { childItems, errorList, selectedSection };
  }

  function onSubmitHandle(event: React.FormEvent<HTMLFormElement>, question: any, handleNext: any, handleSubmit: any, setError: any, message: string = 'Não foi selecionada nenhuma opção') {
    event.preventDefault();

    const { errorList, selectedSection } = processFormElements(event, question);

    handleSubmit(() => {
      applyValidationAndProceed(selectedSection, errorList, setError, message, handleNext);
    }, () => {
      handleValidationLogic(selectedSection, errorList, setError, message);
    })(event);
  }

  function checkAllItemsSelectedAndSetError(selectedSection: any[], errorList: any[], setError: any, message: string) {
    const allItemsSelected = selectedSection.filter(section => {
      if (section.items) {
        return section.items.every((item: any) => errorList.some(x => x.value === item.value));
      }
      return false;
    });
    // Se não houver itens selecionados, exibe um erro
    if (allItemsSelected.length > 0) {
      allItemsSelected.forEach((section: any) => {
        setError(section.value, {
          type: 'validate',
          message: message
        });
      });
    }
    return allItemsSelected.length > 0;
  }

  function applyValidationAndProceed(selectedSection: any[], errorList: any[], setError: any, message: string, handleNext: any) {
    const hasErrors = checkAllItemsSelectedAndSetError(selectedSection, errorList, setError, message);
    if (!hasErrors) {
      handleNext();
    }
  }

  function handleValidationLogic(selectedSection: any[], errorList: any[], setError: any, message: string) {
    checkAllItemsSelectedAndSetError(selectedSection, errorList, setError, message);
  }

  return (
    <TabProvider numberOfTabs={dataTabs.length}>
      <Box maxW="1200px" m="40px auto" overflow="hidden" pl="15px" pr="15px">
        <CustomTabs dataTabs={dataTabs} />
      </Box>
    </TabProvider>
  );
};

export default Questionnaires;
